// extracted by mini-css-extract-plugin
module.exports = {"Account":"Account_Account__1uWuB","Account_tweets":"Account_Account_tweets__3_n5B","pseudo":"Account_pseudo__2JYnw"};